var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetCoinsFilled = function SvgZetCoinsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.3,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zetCoinsFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetCoinsFilled_svg__b)",
    d: "M12 1.896C6.42 1.896 1.897 6.42 1.897 12s4.525 10.104 10.105 10.104S22.105 17.58 22.105 12 17.58 1.896 12 1.896"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#zetCoinsFilled_svg__c)",
    d: "M12 3.2a8.8 8.8 0 1 0 0 17.601 8.8 8.8 0 0 0 0-17.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C4710",
    fillRule: "evenodd",
    d: "M9.97 9.359H5.312v1.627H7.56l-2.246 2.03v1.627H9.97v-1.627H7.724l2.245-2.03zm8.716 0H12.92l.74 1.627h1.707v3.657h1.628v-3.658h1.69zm-6.854 3.657h2.374l.755 1.627h-4.619V9.359h2.165l.741 1.627h-1.416v.28h1.56l.258.555.424.915h-2.242z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "zetCoinsFilled_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.3207 0 0 43.5991 12.001 12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD8F2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "zetCoinsFilled_svg__b",
    x1: 1.899,
    x2: 22.105,
    y1: 11.999,
    y2: 11.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8F2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "zetCoinsFilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgZetCoinsFilled;